

















import {Component, Vue, Prop} from 'vue-property-decorator'
import {Getter, Mutation, Action} from 'vuex-class'
import {Room, InventoryItem} from '@/store/types'
import FontAwesome from '@/classes/FontAwesome'

@Component({})
export default class InventoryAddedItem extends Vue {
  @Getter('activeRoom') public activeRoom!: Room
  @Getter('addedItem') public addedItem!: InventoryItem
  @Mutation('setInventoryAddedItem') public setInventoryAddedItem!: any

  public FontAwesome = FontAwesome

  public closeAddedItem() {
    this.setInventoryAddedItem(false)
  }

}
